import { initializeApp } from "firebase/app";
import {
    getFirestore,
    collection,
    getDoc,
    addDoc,
    query,
    where,
    doc,
    getDocs,
    deleteDoc,
} from "firebase/firestore";
import {
    createUserWithEmailAndPassword,
    getAuth,
    signInWithEmailAndPassword,
} from "firebase/auth";

import { firebaseConfig } from "./KEYS";


const app = initializeApp(firebaseConfig);

const db = getFirestore(app);

export async function GetDate(id) {
    const q = query(collection(db, "dates"), where("id", "==", id + ""));
    const docRef = await getDocs(q);
    const docs = docRef.docs.map((doc) => ({ id: doc.id, data: doc.data() }));
    return docs;
}
export async function DeleteDate(id) {
    await deleteDoc(doc(db, "dates", id));
    return 1;
}
export async function Login(data) {
    try {
        await signInWithEmailAndPassword(getAuth(app), data.mail, data.pass);
        return 1;
    } catch (error) {
        return 0;
    }
}
export async function GetAll() {
    const docRef = await getDocs(collection(db, "dates"));
    const docs = docRef.docs.map((doc) => ({ id: doc.id, data: doc.data() }));
    return docs;
}
export async function Add(data) {
    const docRef = await addDoc(collection(db, "dates"), {
        ...data,
    });
    return { id: docRef.id, data: { ...data } };
}
